import { Button, Row, Col, Card, Modal, InputGroup, Form, Alert } from 'react-bootstrap';
import { setIsLoading } from '../general/actions';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import { currencyFormater, downloadExcel } from '../general/utils';
import ProductImage from '../general/productImage';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectAgreement from '../general/selectAgreement';
import AlertModal from '../general/alertModal';
import { useParams } from 'react-router-dom';


/* ── Modal de detalle de producto ── */
function ProductDetailModal({ item, show, onHide, isCreatingOrder, roles, onSelect }) {
    if (!item) return null;

    const price    = Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1));
    const basePrice = parseFloat(item.price);
    const taxAmt   = price - basePrice;
    const canOrder = roles.includes('customer_order') || roles.includes('provider_order');

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton style={{ background: '#f8fafc', borderBottom: '1px solid var(--abi-border)' }}>
                <Modal.Title style={{ fontWeight: 800, fontSize: 15 }}>
                    <span className="product-card-extid" style={{ marginRight: 8 }}>{item.ext_id}</span>
                    {item.name}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ padding: 0 }}>
                <div className="product-detail-layout">
                    {/* Imagen */}
                    <div className="product-detail-img-wrap">
                        <ProductImage url={item.img_url}
                            alt={item.name}
                            className="product-detail-img"
                        />
                    </div>

                    {/* Info */}
                    <div className="product-detail-info">
                        {item.product_type?.name && (
                            <span className="order-detail-type-badge mb-3" style={{ display: 'inline-block' }}>
                                {item.product_type.name}
                            </span>
                        )}

                        <div className="product-detail-price">{currencyFormater(price)}</div>
                        <div className="product-detail-price-breakdown">
                            <span>Precio base: <strong>{currencyFormater(basePrice)}</strong></span>
                            <span>IVA ({item.taxes}%): <strong>{currencyFormater(taxAmt)}</strong></span>
                        </div>

                        {item.description && (
                            <div className="product-detail-description">
                                {item.description}
                            </div>
                        )}

                        <div className="product-detail-meta">
                            <div className="product-detail-meta-row">
                                <span>Código</span>
                                <strong>{item.ext_id}</strong>
                            </div>
                            <div className="product-detail-meta-row">
                                <span>ID interno</span>
                                <strong>{item.id}</strong>
                            </div>
                            <div className="product-detail-meta-row">
                                <span>IVA / Impuesto</span>
                                <strong>{item.taxes}%</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ background: '#f8fafc', borderTop: '1px solid var(--abi-border)', gap: 8 }}>
                <Button variant="outline-secondary" size="sm" onClick={onHide}>
                    Cerrar
                </Button>
                {canOrder && (
                    <Button variant="primary" size="sm" onClick={() => { onSelect(item); onHide(); }}>
                        <i className="fa fa-cart-plus" />
                        {' '}{isCreatingOrder ? 'Agregar al pedido' : 'Crear pedido'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

/* ── Fila de producto (vista lista) ── */
function ProductRow({ item, isCreatingOrder, roles, onSelect, onDetail }) {
    const price    = Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1));
    const canOrder = roles.includes('customer_order') || roles.includes('provider_order');

    return (
        <tr className="product-list-row">
            <td style={{ width: 52 }}>
                <ProductImage url={item.img_url}
                    alt={item.name}
                    className="order-detail-thumb pointer"
                    onClick={() => onDetail(item)}
                />
            </td>
            <td>
                <div className="product-card-name pointer" onClick={() => onDetail(item)}>
                    <span className="product-card-extid">{item.ext_id}</span>
                    {item.name}
                </div>
                {item.description && (
                    <div style={{ fontSize: 12, color: 'var(--abi-muted)', marginTop: 2 }}>
                        {item.description.length > 100 ? item.description.slice(0, 100) + '…' : item.description}
                    </div>
                )}
            </td>
            <td className="d-none d-md-table-cell">
                <span className="order-detail-type-badge">{item.product_type?.name}</span>
            </td>
            <td style={{ whiteSpace: 'nowrap' }}>
                <div style={{ fontWeight: 700, color: 'var(--abi-primary)', fontSize: 14 }}>{currencyFormater(price)}</div>
                <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>+ {item.taxes}% IVA</div>
            </td>
            {canOrder && (
                <td style={{ textAlign: 'right' }}>
                    <Button size="sm" variant="primary" onClick={() => onSelect(item)}>
                        <i className="fa fa-cart-plus" /> {isCreatingOrder ? 'Agregar' : 'Pedir'}
                    </Button>
                </td>
            )}
        </tr>
    );
}

/* ── Tarjeta de producto ── */
function ProductCard({ item, isCreatingOrder, roles, onSelect, onDetail }) {
    const price    = Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1));
    const canOrder = roles.includes('customer_order') || roles.includes('provider_order');

    return (
        <Card className="product-card h-100">
            <div className="product-card-img-wrap" onClick={() => onDetail(item)} title="Ver detalle">
                <ProductImage url={item.img_url}
                    alt={item.name}
                    className="product-card-img pointer"
                />
                <div className="product-card-img-overlay">
                    <i className="fa fa-search-plus" />
                </div>
            </div>
            <Card.Body className="d-flex flex-column">
                <div
                    className="product-card-name mb-1 pointer"
                    onClick={() => onDetail(item)}
                    title="Ver detalle"
                >
                    <span className="product-card-extid">{item.ext_id}</span>
                    {item.name}
                </div>
                <div className="product-card-price mb-2">
                    {currencyFormater(price)}
                    <span className="product-card-tax">+ {item.taxes}% IVA</span>
                </div>

                {item.description && (
                    <p className="product-card-desc text-muted mb-0">
                        {item.description.length > 90
                            ? item.description.slice(0, 90) + '…'
                            : item.description}
                    </p>
                )}

                {canOrder && (
                    <Button
                        variant="primary"
                        className="mt-auto product-card-btn"
                        onClick={() => onSelect(item)}
                    >
                        <i className="fa fa-cart-plus" />
                        {' '}{isCreatingOrder ? 'Agregar al pedido' : 'Crear pedido'}
                    </Button>
                )}
            </Card.Body>
        </Card>
    );
}

/* ── Componente principal ── */
function Products(props) {
    const { setIsLoading, productSel, roles } = props;
    const { agreementSel } = useParams();

    const [isCreatingOrder]  = useState(props.isCreatingOrder);
    const [products, setProducts]   = useState([]);
    const [searchText, setSearchText] = useState('');
    const [agreement, setAgreement]   = useState((props.agreement || agreementSel) || '');
    const [message, setMessage]       = useState('');
    const [messageType, setMessageType] = useState('info');

    const [viewMode, setViewMode] = useState(() => localStorage.getItem('productsViewMode') || 'grid');
    const [agreementLabel, setAgreementLabel] = useState('');
    const fetchedAgreementRef = useRef(null);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDetail, setShowDetail]           = useState(false);

    const setView = (mode) => { setViewMode(mode); localStorage.setItem('productsViewMode', mode); };

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg]   = useState('');
    const [alertModalType, setAlertModalType] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (products.length && productSel) {
            const item = products.find(p => p.id == productSel);
            if (item) { selectProduct(item); props.setProductSel(''); }
        }
    }, [products]);

    useEffect(() => {
        if (agreement) {
            if (agreement === fetchedAgreementRef.current) return;
            fetchedAgreementRef.current = agreement;
            getProducts();
        } else {
            fetchedAgreementRef.current = null;
            setProducts([]);
            setMessage('Selecciona un contrato para ver los productos');
        }
    }, [agreement]);

    const openDetail = (item) => {
        setSelectedProduct(item);
        setShowDetail(true);
    };

    const selectProduct = (item) => {
        if (isCreatingOrder) {
            props.addProduct(item);
        } else {
            navigate(`/order/create/${agreement}/${item.id}`);
        }
    };

    const getProducts = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/products/agreements/${agreement}`);
            setProducts(response.data);
            if (!response.data.length) {
                setMessageType('warning');
                setMessage('El contrato seleccionado no tiene productos asociados');
            } else {
                setMessage('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const filtered = products.filter(item =>
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.description.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleExcel = () => {
        const headers = ['Código', 'Nombre', 'Tipo', 'Descripción', 'Precio base', 'IVA %', 'Precio c/IVA'];
        const rows = filtered.map(item => {
            const priceWithTax = Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1));
            return [
                item.ext_id ?? '',
                item.name ?? '',
                item.product_type?.name ?? '',
                item.description ?? '',
                parseFloat(item.price),
                parseFloat(item.taxes),
                priceWithTax,
            ];
        });
        const sheetName = agreementLabel ? agreementLabel.slice(0, 31) : 'Catalogo';
        downloadExcel(headers, rows, 'Catálogo de productos', sheetName);
    };

    const handlePrint = () => {
        const rows = filtered.map(item => {
            const price = Math.round(parseFloat(item.price) * ((parseFloat(item.taxes) / 100) + 1));
            return `
                <tr>
                    <td>${item.ext_id || 'N/A'}</td>
                    <td>${item.name}</td>
                    <td>${item.product_type?.name || ''}</td>
                    <td style="text-align:right">${item.description || ''}</td>
                    <td style="text-align:right;white-space:nowrap">${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(price)}</td>
                    <td style="text-align:right">${item.taxes}%</td>
                </tr>`;
        }).join('');

        const ventana = window.open('', '_blank');
        ventana.document.write(`
            <html>
            <head>
                <title>Catálogo de productos</title>
                <style>
                    @page { margin: 1.5cm; }
                    * { box-sizing: border-box; }
                    body { font-family: 'Calibri', sans-serif; font-size: 0.75rem; margin: 0; color: #000; }
                    h2 { font-size: 1rem; margin: 0 0 4px; }
                    p  { font-size: 0.7rem; margin: 0 0 12px; color: #555; }
                    table { border-collapse: collapse; width: 100%; }
                    th, td { padding: 4px 6px; vertical-align: top; font-size: inherit; border: 1px solid #ccc; }
                    thead tr { background: #f0f0f0; }
                    tbody tr:nth-child(even) { background: #fafafa; }
                </style>
            </head>
            <body>
                <h2>Catálogo de productos</h2>
                ${agreementLabel ? `<p style="margin:0 0 4px;font-size:0.75rem;color:#333"><strong>Contrato:</strong> ${agreementLabel}</p>` : ''}
                <p>${filtered.length} producto${filtered.length !== 1 ? 's' : ''}${searchText ? ` — filtro: "${searchText}"` : ''}</p>
                <table>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            <th>Descripción</th>
                            <th style="text-align:right">Precio c/IVA</th>
                            <th style="text-align:right">IVA</th>
                        </tr>
                    </thead>
                    <tbody>${rows}</tbody>
                </table>
            </body>
            </html>
        `);
        ventana.document.close();
        ventana.print();
        ventana.close();
    };

    return (
        <>
            {/* Header */}
            <div className="products-header">
                <div className="products-header-top">
                    <div>
                        <h5 className="products-title mb-0">Catálogo de productos</h5>
                        {products.length > 0 && (
                            <span className="text-muted" style={{ fontSize: 13 }}>
                                {filtered.length} de {products.length} producto{products.length !== 1 ? 's' : ''}
                            </span>
                        )}
                    </div>
                    <div className="products-header-actions">
                        {!isCreatingOrder && (
                            <div style={{ minWidth: 280 }}>
                                <SelectAgreement
                                    agreement={agreement}
                                    setAgreement={setAgreement}
                                    onSelect={setAgreementLabel}
                                />
                            </div>
                        )}
                        <InputGroup style={{ maxWidth: 280 }}>
                            <Form.Control
                                placeholder="Buscar producto…"
                                type="text"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                disabled={!agreement}
                                className="products-search"
                            />
                            {searchText && (
                                <Button variant="outline-secondary" onClick={() => setSearchText('')} title="Limpiar">
                                    <i className="fa fa-times" />
                                </Button>
                            )}
                        </InputGroup>

                        {/* Toggle de vista */}
                        <div className="products-view-toggle">
                            <button
                                className={`products-view-btn${viewMode === 'grid' ? ' active' : ''}`}
                                onClick={() => setView('grid')}
                                title="Vista en cuadrícula"
                            >
                                <i className="fa fa-th" />
                            </button>
                            <button
                                className={`products-view-btn${viewMode === 'list' ? ' active' : ''}`}
                                onClick={() => setView('list')}
                                title="Vista en lista"
                            >
                                <i className="fa fa-list" />
                            </button>
                        </div>

                        {filtered.length > 0 && (
                            <>
                                <Button
                                    variant="outline-success"
                                    size="sm"
                                    onClick={handleExcel}
                                    title="Exportar a Excel"
                                >
                                    <i className="fa fa-file-excel-o" />
                                </Button>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={handlePrint}
                                    title="Imprimir listado"
                                >
                                    <i className="fa fa-print" />
                                </Button>
                            </>
                        )}
                    </div>
                </div>
                <hr className="mt-3 mb-0" />
            </div>

            {message && (
                <Alert variant={messageType || 'info'} className="mt-3">
                    {message}
                </Alert>
            )}

            {/* Grid / Lista */}
            {viewMode === 'grid' ? (
                <Row className="g-3 mt-1">
                    {filtered.map(item => (
                        <Col md={3} sm={6} xs={12} key={'product-' + item.id}>
                            <ProductCard
                                item={item}
                                isCreatingOrder={isCreatingOrder}
                                roles={roles}
                                onSelect={selectProduct}
                                onDetail={openDetail}
                            />
                        </Col>
                    ))}
                </Row>
            ) : (
                <div style={{ overflowX: 'auto', marginTop: 12 }}>
                    <table className="report-table mb-0" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th style={{ width: 52 }}></th>
                                <th>Producto</th>
                                <th className="d-none d-md-table-cell">Tipo</th>
                                <th>Precio</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map(item => (
                                <ProductRow
                                    key={'product-' + item.id}
                                    item={item}
                                    isCreatingOrder={isCreatingOrder}
                                    roles={roles}
                                    onSelect={selectProduct}
                                    onDetail={openDetail}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <ProductDetailModal
                item={selectedProduct}
                show={showDetail}
                onHide={() => setShowDetail(false)}
                isCreatingOrder={isCreatingOrder}
                roles={roles}
                onSelect={selectProduct}
            />

            <AlertModal
                show={alertModalShow}
                setShow={setAlertModalShow}
                msg={alertModalMsg}
                setMsg={setAlertModalMsg}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading, roles: state.roles };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(Products);
